import { render, staticRenderFns } from "./Nodata.vue?vue&type=template&id=0b63ef22&scoped=true&"
import script from "./Nodata.vue?vue&type=script&lang=js&"
export * from "./Nodata.vue?vue&type=script&lang=js&"
import style0 from "./Nodata.vue?vue&type=style&index=0&id=0b63ef22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63ef22",
  null
  
)

component.options.__file = "Nodata.vue"
export default component.exports